// Get ID to refer to named package in GQL
export default function mapPackageToId(packageName) {
  switch (packageName) {
    case 'UK': return 1;
    case 'US': return 2;
    case 'EU': return 3;
    case 'Global': return 4;
    default: return null;
  }
}



// WEBPACK FOOTER //
// ./app/utils/AYDAUtils/mapPackageToId.js